<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ config.headline }}
    </mat-card-title>
    <mat-card-subtitle> {{ availableLocation?.name }}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="max-w-5xl">
    @if (imageToShow) {
      <img class="max-w-full" [src]="imageToShow" />
    }
    <div class="flex flex-row items-center justify-around mt-4">
      <mat-icon class="cursor-pointer" (click)="skipToPreviousFrame()">
        skip_previous
      </mat-icon>
      <mat-icon class="cursor-pointer" (click)="toggleAutplay()">
        {{ (autoPlayIsRunning$ | async) ? "pause_circle" : "play_circle" }}
      </mat-icon>
      <mat-icon class="cursor-pointer" (click)="skipToNextFrame()">
        skip_next
      </mat-icon>
    </div>

    @if (availableTimestamps?.length > 0) {
      <mat-slider
        min="0"
        [max]="availableTimestamps?.length - 1"
        step="1"
        showTickMarks
        discrete
        [displayWith]="formatSliderLabel"
        style="width: 100%"
        >
        <input
          matSliderThumb
          [(ngModel)]="currentTimestamp"
          (change)="onSliderChange($event)"
          #slider
          />
      </mat-slider>
    }
    <div class="flex flex-row justify-center">
      <p>
        {{ availableTimestamps[currentTimestamp]?.timestamp | date : "medium" }}
        Uhr
      </p>
    </div>
  </mat-card-content>

  @if (userService.userIsAdmin) {
    <mat-card-actions>
      <button
        mat-button
        (click)="reportModuleService.openEditReportModuleForm(config.guid)"
        >
        BEARBEITEN
      </button>
      <button
        (click)="reportModuleService.removeModuleFormReport(config.guid)"
        mat-button
        >
        LÖSCHEN
      </button>
    </mat-card-actions>
  }
</mat-card>
